import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faEraser } from "@fortawesome/free-solid-svg-icons";

export default function DeleteBtn({ handleOnClick, value, t, small }) {

    function DeleteConfirm() {
        return (
            <div id="deleteConfirmModal"
                className="modal fade bg-transparent"
                tabIndex="-1"
                aria-hidden="true"
                aria-labelledby="deleteConfirmLabel"
                data-bs-backdrop="static" data-bs-keyboard="false">

                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteConfirmLabel">{t("DeletConfirmtitle")}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {t("DeleteConfirmMsg")}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-masar-sm btn-med-gray" data-bs-dismiss="modal">{t("Cancel")}</button>
                            <button type="button" className="btn-masar-sm btn-dark-orange" onClick={handleOnClick}>{t("Delete")}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <>
            {small ? (
                <button
                    className={`btn-masar-sm btn-dark-orange rounded position-absolute top-0 end-0 m-0
            ${value === "Rejected" ? `position-absolute top-0 end-0 m-1` : ""}`}
                    // onClick={handleOnClick}
                    value={value}
                >
                    <FontAwesomeIcon icon={faBan}
                        data-bs-toggle="modal"
                        data-bs-target="#deleteConfirmModal"
                    />
                </button>
            ) : (<button
                className={`btn-masar btn-dark-orange text-white p-1 rounded me-3 
            ${value === "Rejected" ? `position-absolute top-0 end-0 m-1` : ""}`}
                // onClick={handleOnClick}
                value={value}
            >
                <FontAwesomeIcon icon={faEraser}
                    data-bs-toggle="modal"
                    data-bs-target="#deleteConfirmModal"
                />
            </button>)}
            <DeleteConfirm />
        </>
    );
}